import { useStrategy } from '../strategy';
import { usePlanMeta } from './plan';

export function usePlanStrategy() {
  return useStrategy(usePlanMeta().plan_strategy);
}
